import { Component, OnInit } from '@angular/core';
import { EMailService } from '../../../services/email.service';
import { EDeliveryService } from '../../../services/edelivery.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, Subscription } from 'rxjs';
// import { debounceTime } from 'rxjs/operators';
import { Email } from '../../../models/e-mail.model';
import { Emailresponse } from '../../../models/emailresponse.model';
import { Inject } from '@angular/core';
import { LogService } from '@pershing/pershing-core';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { EdeliveryLabels } from '../../../i18n/edelivery-labels';
import { PershingTranslationService } from '@pershing/pershing-core';

@Component({
  selector: 'editEmail',
  templateUrl: './editEmail.component.html',
  styleUrls: ['./editEmail.component.css']
})
export class EditEmailComponent implements OnInit {
  emailResponse: Observable<Emailresponse>;
  confirmEmail: string = '';
  errorMessage: string;
  editEmail: string = '';
  oldEmail: string = '';
  emailToBeSubmitted: Email;
  currentEmails: Email[];
  log: LogService;
  closePopup: boolean = false;
  editEmailSubscription: Subscription;

  // Labels
  editEmailTitle = EdeliveryLabels.EDIT_EMAIL_ADDRESS;
  emailLabel = EdeliveryLabels.EMAIL_LABEL;
  confirmEmailLabel = EdeliveryLabels.CONFIRM_EMAIL_LABEL;
  invalidEmailAddress = EdeliveryLabels.INVALID_EMAIL;
  invalidEmailAddressMaxLength = EdeliveryLabels.INVALID_EMAIL_MAXLENGTH;
  saveLabel = EdeliveryLabels.SAVE;
  cancelLabel = EdeliveryLabels.CANCEL;

  emailForm = new FormGroup({
    'editEmail': new FormControl('', [
      Validators.required,
      Validators.email,
      Validators.maxLength(64),
      Validators.pattern('^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')
    ]),
    'confirmEmail': new FormControl('', [
      Validators.required,
      Validators.email,
      Validators.maxLength(64),
      Validators.pattern('^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')
    ])
  });

  constructor(private emailService: EMailService, private edeliveryService: EDeliveryService,
              public dialogRef: MatDialogRef<EditEmailComponent>, @Inject(MAT_DIALOG_DATA) public data: any, log: LogService,
              private translate: PershingTranslationService) {
    this.log = log;
    log.info(data.email);
    this.oldEmail = data.email.emailAddress;
    this.emailForm.get('editEmail').setValue(this.data.email.emailAddress);
    this.emailForm.get('confirmEmail').setValue(this.data.email.emailAddress);
    this.editEmail = this.data.email.emailAddress;
    this.confirmEmail = this.data.email.emailAddress;
    this.emailToBeSubmitted = data.email;

    if (this.translate) {
      this.translate.addTranslationFolder('@pershing/edc-edelivery', 'node_modules/@pershing/edc-edelivery/lib');
    }
  }

  ngOnInit() {
    this.log.info(this.editEmail);
    this.currentEmails = this.emailService.getUserEmails();
    console.log('current emails: ', this.currentEmails);
    this.emailResponse = this.emailService.emailresponse$;
  }

  ngOnDestroy() {
    if (this.editEmailSubscription) {
        this.editEmailSubscription.unsubscribe();
    }
  }

  saveEmail(): void {
    this.editEmail = this.emailForm.value.editEmail.toUpperCase();
    this.confirmEmail = this.emailForm.value.confirmEmail.toUpperCase();
    console.log('Emails: ', this.editEmail, this.confirmEmail);
    if (this.editEmail !== this.confirmEmail) {
      this.log.info('Email and confirm e-mail do not match');
      this.errorMessage = 'Email and confirm e-mail do not match';
      if (this.translate.translate.store.currentLang === 'es') {
        this.errorMessage = 'La dirección de correo electrónico ingresada en los dos campos no coincide. Corríjalos.';
      }
      return;
    }
    if (this.oldEmail === this.editEmail) {
      this.dialogRef.close();
      return;
    }
    for (let i = 0; i < this.currentEmails.length; i++) {
      if (this.currentEmails[i].emailAddress === this.editEmail) {
        this.errorMessage = 'Only one valid e-mail address is required. If you choose to provide more than' +
                             ' the one required address, each e-mail you enter must be distinct from the previous entry.';
        if (this.translate.translate.store.currentLang === 'es') {
            this.errorMessage = 'Solo se requiere una dirección de correo electrónico válida.' +
            ' Si elige proporcionar más que la dirección requerida,' +
            ' cada correo electrónico que ingrese debe ser diferente de la entrada anterior.';
        }
        return;
      }
    }
    this.emailToBeSubmitted.emailAddress = this.editEmail;
    this.emailService.updateEmails(this.emailToBeSubmitted);
    this.edeliveryService.triggerLoadingIcon(true);
    this.emailService.updateEmailTriggered = true;
    this.close();
    // this.closePopup = true;
  }
  close() {
    this.dialogRef.close();
  }

}
